import React, { useState } from "react";
import { formatDate } from "../../utils/dateUtils.js";
import { showPromiseToast } from "../../services/toastService.js";
import { runAction } from "../../services/actionsService.js";
import { useAuth } from "../../contexts/AuthContextProvider.jsx";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { FaPlay } from "react-icons/fa";
import classNames from "classnames";

const ActionManagement = ({ state, setState }) => {
	const { user } = useAuth();
	const [runningActions, setRunningActions] = useState([]);

	const handleRunAction = (id) => {
		setRunningActions((prev) => [...prev, id]);

		showPromiseToast(runAction(id), {
			pending: "Esecuzione azione in corso...",
			success: "Azione eseguita con successo",
		})
			.then((res) => {
				const updatedActions = state.map((action) =>
					action.id === id
						? {
								...action,
								last_run: new Date(),
								last_run_by: user.username,
								result: JSON.stringify(res.data),
						  }
						: action
				);

				setState(updatedActions);
			})
			.catch((err) => {
				const updatedActions = state.map((action) =>
					action.id === id
						? {
								...action,
								last_run: new Date(),
								last_run_by: user.username,
								result: JSON.stringify(err.data),
						  }
						: action
				);
				setState(updatedActions);
			})
			.finally(() => {
				setRunningActions((prev) => prev.filter((actionId) => actionId !== id));
			});
	};

	return (
		<div>
			<h2 className="text-2xl font-bold mb-4 text-center">Gestione Azioni</h2>

			{/* Tabella Azioni */}
			<table className="w-full border-collapse border border-gray-300 hidden sm:table">
				<thead>
					<tr className="bg-gray-200">
						<th className="border border-gray-300 p-2">ID</th>
						<th className="border border-gray-300 p-2">Nome</th>
						<th className="border border-gray-300 p-2">Ultima Esecuzione</th>
						<th className="border border-gray-300 p-2">Risultato</th>
						<th className="border border-gray-300 p-2">Eseguita da</th>
						<th className="border border-gray-300 p-2">Azione</th>
					</tr>
				</thead>
				<tbody>
					{state.map((action) => (
						<tr key={action.id} className="hover:bg-gray-200 text-center">
							<td className="border border-gray-300 p-2">{action.id}</td>
							<td className="border border-gray-300 p-2">{action.name}</td>
							<td className="border border-gray-300 p-2">
								{formatDate(action.last_run) || "N/A"}
							</td>
							<td className="border border-gray-300 p-2">
								<div
									className={classNames(
										"flex items-center justify-center text-center gap-2",
										{
											"text-green-700": !!JSON.parse(action.result)?.success,
											"text-red-700": !JSON.parse(action.result)?.success,
										}
									)}
								>
									{JSON.parse(action.result)?.success ? (
										<FaCheckCircle className="text-green-500 w-5 h-5" />
									) : (
										<FaTimesCircle className="text-red-500 w-5 h-5" />
									)}
									<span>{JSON.parse(action.result)?.message}</span>
								</div>
							</td>
							<td className="border border-gray-300 p-2">
								{action.last_run_by || (
									<span className="italic">Esecuzione Automatica</span>
								)}
							</td>
							<td className="border border-gray-300 p-2">
								<button
									id="run"
									aria-label="Esegui Azione"
									onClick={() => handleRunAction(action.id)}
									className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
									disabled={runningActions.includes(action.id)}
								>
									<FaPlay />
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			{/* Layout per schermi piccoli */}
			<div className="sm:hidden">
				{state.map((action) => (
					<div
						key={action.id}
						className="border border-gray-300 p-4 mb-4 rounded shadow bg-white"
					>
						<div className="flex justify-between mb-2">
							<span className="font-bold">ID:</span>
							<span>{action.id}</span>
						</div>
						<div className="flex justify-between mb-2">
							<span className="font-bold">Nome:</span>
							<span>{action.name}</span>
						</div>
						<div className="flex justify-between mb-2">
							<span className="font-bold">Ultima Esecuzione:</span>
							<span>{formatDate(action.last_run) || "N/A"}</span>
						</div>
						<div className="flex justify-between mb-2">
							<span className="font-bold">Eseguita da:</span>
							<span>
								{action.last_run_by || (
									<span className="italic">Esecuzione Automatica</span>
								)}
							</span>
						</div>
						<div className="flex justify-between items-center mb-2">
							<div className="flex items-center justify-end gap-2">
								{JSON.parse(action.result)?.success ? (
									<FaCheckCircle className="text-green-500 w-5 h-5" />
								) : (
									<FaTimesCircle className="text-red-500 w-5 h-5" />
								)}
								<span>{JSON.parse(action.result)?.message}</span>
							</div>
						</div>
						<div className="flex justify-end">
							<button
								id="run"
								aria-label="Esegui Azione"
								onClick={() => handleRunAction(action.id)}
								className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
								disabled={runningActions.includes(action.id)}
							>
								<FaPlay />
							</button>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default ActionManagement;
